import { z } from "zod";

export const PrivateMiscControllerResponseSchema = {
  submitContactForm: z.boolean(),
};
